import { GruppoTerritoriale } from '../gruppo-territoriale';

export class TemplateProfilo {
  id: string;
  label?: string;
  nomeRuolo?: string;
  constructor( gruppoTerritoriale: GruppoTerritoriale) {
    this.id = gruppoTerritoriale.id;
    this.label = gruppoTerritoriale.nomeGruppo;
  }
}
